module.exports = __webpack_public_path__ + "img/logo.5692b3ce.png";